import * as ProductSelectorActions from '../actions/product-selector.actions';

export interface ProductSelectorState {
  selectedProduct: any;
}

export const initialState: ProductSelectorState = {
  selectedProduct: undefined,
};

export function reducer(
  state: ProductSelectorState = initialState,
  action: ProductSelectorActions.Actions,
): ProductSelectorState {
  switch (action.type) {
    case ProductSelectorActions.SELECT_DEEP_LINK_PRODUCT:
      return {
        ...state,
        selectedProduct: action.payload,
      };
    default:
      return state;
  }
}

export const getSelectedProduct = (state: ProductSelectorState) =>
  state.selectedProduct;
